import { PostMessageRequest } from "./types";
import { PostMessageRepository } from "./PostMessageRepository";

export class PostMessageSender{
    private readonly targetWindow: Window;
    private readonly targetOrigin: string;
    private postMessageRepository: PostMessageRepository;
    constructor(targetWindow: Window, targetOrigin: string, postMessageRepository: PostMessageRepository) {
        this.targetWindow = targetWindow;
        this.targetOrigin = targetOrigin;
        this.postMessageRepository = postMessageRepository;
    }

    public sendMessage(postMessageRequest: PostMessageRequest): void {
       this.targetWindow.postMessage(postMessageRequest.data, this.targetOrigin);
       this.postMessageRepository.setPostMessageRequestStatus(postMessageRequest.responseIdentifier, 'PENDING');
    }
}